export const Avatar = ({
  size,
  name,
  surname,
  textSize,
}: {
  size: number;
  name: string;
  surname: string;
  textSize?: number;
}) => {
  const initials = name.charAt(0) + surname.charAt(0);
  return (
    <div
      style={{
        width: size,
        height: size,
        background: "linear-gradient(135deg, #FF7C67 0%, #7C3AED 100%)",
      }}
      className="rounded-full flex items-center justify-center"
    >
      <span className="text-white uppercase" style={{ fontSize: textSize ? textSize : size / 2.5 }}>
        {initials}
      </span>
    </div>
  );
};
